import { BrowserRouter, NavLink, Route, Routes } from 'react-router-dom';
import { SessionProvider, useSession } from './auth/session.js';
import { Brand } from './routes/setup.js';
import { LoginRoute } from './routes/login.js';
import { SetupRoute } from './routes/setup.js';
import { DashboardRoute } from './routes/dashboard.js';
import { BusinessAccountsRoute } from './routes/business-accounts.js';
import { TemplatesRoute } from './routes/templates.js';
import { ContactsRoute } from './routes/contacts.js';
import { CampaignsRoute } from './routes/campaigns.js';
import { DeliveriesRoute } from './routes/deliveries.js';
import { SettingsRoute } from './routes/settings.js';
import { DeploymentNotice } from './deployment-notice.js';
import { BusinessScopeProvider, useBusinessAccounts } from './business/scope.js';
import { BusinessSelector } from './business/selector.js';
import { SystemStatusProvider } from './system/status.js';
import './operations.css';
import { SessionControls } from './auth/controls.js';
import './finishing.css';

const navigation = [
  ['/', 'Visão geral'], ['/business-accounts', 'BMs e números'], ['/templates', 'Templates'],
  ['/contacts', 'Contatos'], ['/campaigns', 'Campanhas'], ['/deliveries', 'Entregas'], ['/settings', 'Configurações'],
] as const;

const ProtectedShell = () => {
  const { state } = useSession();
  if (state === 'loading') return <main className="boot-state" aria-busy="true"><span className="pulse-line"/>Verificando sessão…</main>;
  if (state === 'guest') return <LoginRoute />;
  return <BusinessScopeProvider><SystemStatusProvider><AuthenticatedShell /></SystemStatusProvider></BusinessScopeProvider>;
};

const AuthenticatedShell = () => {
  const { account, accounts, error: accountError } = useBusinessAccounts();
  // Changing BM unmounts every tenant-specific form, result and pending confirmation.
  const scopeKey = account?.id ?? 'no-business-account';
  return <div className="app-frame">
    <aside className="rail">
      <Brand />
      <nav aria-label="Navegação principal">
        {navigation.map(([to, label]) => <NavLink key={to} to={to} end={to === '/'}><span className="nav-tick" aria-hidden="true"/>{label}</NavLink>)}
      </nav>
    </aside>
    <main className="workspace">
      <SessionControls />
      <DeploymentNotice />
      <BusinessSelector />
      {accounts === null && !accountError ? <section className="state-panel" aria-busy="true"><h1>Carregando operação</h1><p>Confirmando a conta comercial antes de abrir os formulários…</p></section> : <Routes>
        <Route path="/" element={<DashboardRoute key={scopeKey} />} />
        <Route path="/business-accounts" element={<BusinessAccountsRoute />} />
        <Route path="/templates" element={<TemplatesRoute key={scopeKey} />} />
        <Route path="/contacts" element={<ContactsRoute key={scopeKey} />} />
        <Route path="/campaigns" element={<CampaignsRoute key={scopeKey} />} />
        <Route path="/deliveries" element={<DeliveriesRoute key={scopeKey} />} />
        <Route path="/settings" element={<SettingsRoute key={scopeKey} />} />
      </Routes>}
    </main>
  </div>;
};

export const App = () => <BrowserRouter><Routes>
  <Route path="/setup" element={<SetupRoute />} />
  <Route path="/*" element={<SessionProvider><ProtectedShell /></SessionProvider>} />
</Routes></BrowserRouter>;
